import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c6d1f7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-cen",
  style: {"width":"100%"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"max-width":"200px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/InfoIconSVG.svg",
  alt: "",
  class: "cursor-pt"
}, null, -1))
const _hoisted_5 = { class: "text-rt mt_10" }

import { ref, reactive, computed } from 'vue'
import { t } from '@/plugins/i18n'
import STable from '@/components/Table/index.vue'
import { getProductList as storeProd } from '@/apis/stock'
import { getCartRecords } from '@/apis/shopcart'
import { ProductTypes } from '@/store/modules/goods'
import { ElMessage } from 'element-plus'
import { goodsPropName } from '@/util/useFormat'
import { isMultiStore } from '@/store'
import { formatMoney } from '@/plugins/utils'
import { tCurrency } from '../country'


export default /*#__PURE__*/_defineComponent({
  props: ['type', 'hasSet', 'list', 'countryCode'],
  emits: ['commit'],
  setup(__props, { emit }) {

const props = __props



const sourceCountry = [
  { label: t('中国'), value: 'CN' },
  { label: t('韩国'), value: 'KR' }
]
const data = ref([])
const indeterminate = computed(
  () => !checkAll.value && data.value.some((v: any) => v.productSku in selected)
)
const checkAll = computed({
  get: () => {
    return (
      data.value.length > 0 &&
      data.value.every((v: any) => v.productSku in selected)
    )
  },
  set: (val) => {
    data.value.map((v: any) => {
      handleCheck(val, v)
    })
  }
})
const selected: any = reactive({})
const handleCheck = (is: boolean, row: any) => {
  const key = row.productSku
  if (props.hasSet.has(key)) {
    return
  }
  if (is) {
    selected[key] = row
  } else {
    delete selected[key]
  }
}
const commit = () => {
  const data = Object.values(selected)
  const { size } = props.hasSet
  if (size + data.length > 30) {
    ElMessage.error(t('超过组合sku数量，一个组合商品至多由30种不同单品sku组成'))
    return
  }
  if (!data.length) {
    ElMessage.error(t('至少选一个'))
  }
  //   将外层的数据一起放在一块
  const newData = (props.list ?? []).concat(data ?? [])
  //   是否都是一个国家下的商品
  const isCommonGoodsCountry = newData.every((item: any) => item.goodsCountry === newData[0]?.goodsCountry)
  if (!isCommonGoodsCountry) {
    ElMessage.error(t('不同国家的商品无法组合'))
    return
  }
  // 加入到组合时，默认数量一个
  data.forEach((v: any) => {
    v.productSkuImg = v.productSkuImg || v.productMainImg
    v.productTitleJp = v.productTitleJp || v.productTitle
    v.productSellPrice = v.productSellPrice || v.unitPrice
    v.unitNums = 1
  })
  console.log(data)
  emit('commit', data)
}

const pageData = ref({
  page: 1,
  limit: 30
})
const model = reactive({
  productType: '',
  productSkuOrName: '',
  goodsCountry: props.countryCode ?? 'CN'
})

const filterData = computed(() => {
  if (model.productType) {
    return { ...model }
  } else {
    return {
      productSkuOrName: model.productSkuOrName,
      productType: '1,2',
      goodsCountry: isMultiStore() ? model?.goodsCountry : undefined
    }
  }
})

const reset = () => {
  pageData.value = {
    page: 1,
    limit: 30
  }
  model.productSkuOrName = ''
  model.productType = ''
  requestAnimationFrame(search)
}
const search = () => {
  Object.keys(selected).forEach((k) => {
    delete selected[k]
  })
  table.value.getData()
}

const table: any = ref(null)

const sku = props.type
  ? [
    {
      label: 'sku',
      align: 'center',
      prop: 'productSku'
    }
  ]
  : []
const multiStore = isMultiStore() ? [
  {
    align: 'center',
    prop: 'goodsCountry',
    slotName: 'goodsCountry',
    slotHeadName: 'goodsCountryTitle'
  }
] : []
const columns = [
  {
    label: '图片',
    prop: 'checked',
    align: 'center',
    slotHeadName: 'checkAll',
    slotName: 'checkbox',
    width: 55
  },
  ...sku,
  { label: '图片', prop: 'productSkuImg', align: 'center', slotName: 'image' },
  {
    label: '商品名称',
    prop: 'productTitleJp',
    align: 'center',
    slotName: 'title'
  },
  { label: '商品类型', prop: 'productType', align: 'center', slotName: 'type' },
  {
    label: '商品规格',
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'property'
  },
  ...multiStore,
  {
    label: '单价',
    prop: 'productSellPrice',
    align: 'center',
    slotName: 'price'
  }
].fort()

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, { inline: true }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(t)('商品类型')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(model).productType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).productType) = $event)),
              teleported: false,
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ProductTypes).slice(0, -1), (v) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: v.label,
                    value: v.value,
                    label: v.label
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_unref(isMultiStore)())
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _unref(t)('国家筛选')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(model).goodsCountry,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).goodsCountry) = $event)),
                  teleported: false,
                  style: {"width":"120px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sourceCountry, (v) => {
                      return _createVNode(_component_el_option, {
                        key: v.label,
                        value: v.value,
                        label: v.label
                      }, null, 8, ["value", "label"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('商品名称/SKU')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(model).productSkuOrName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).productSkuOrName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          class: "fl-r",
          style: {"margin-right":"0px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: search
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              class: "btn act",
              onClick: reset
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(STable, {
      ref: (_value, _refs) => {
        _refs['table'] = _value
        table.value = _value
      },
      "page-data": pageData.value,
      "onUpdate:page-data": _cache[4] || (_cache[4] = ($event: any) => ((pageData).value = $event)),
      columns: _unref(columns),
      filterData: _unref(filterData),
      api: __props.type ? _unref(storeProd) : _unref(getCartRecords),
      height: "400px",
      "row-class-name": ({ row }: any) => (__props.hasSet.has(row.productSku) ? 'gray' : ''),
      onDataListener: _cache[5] || (_cache[5] = (val) => (data.value = val))
    }, {
      checkAll: _withCtx(() => [
        _createVNode(_component_el_checkbox, {
          modelValue: _unref(checkAll),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(checkAll) ? (checkAll).value = $event : null)),
          indeterminate: _unref(indeterminate)
        }, null, 8, ["modelValue", "indeterminate"])
      ]),
      checkbox: _withCtx(({ row }) => [
        _createVNode(_component_el_checkbox, {
          onChange: (v) => handleCheck(v, row),
          "model-value": row.productSku in _unref(selected),
          disabled: __props.hasSet.has(row.productSku) || [1, 3].includes(row.oemOrderType)
        }, null, 8, ["onChange", "model-value", "disabled"])
      ]),
      image: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "pt_img",
            src: row.productSkuImg || row.productMainImg,
            alt: ""
          }, null, 8, _hoisted_2)
        ])
      ]),
      title: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(row.productTitleJp || row.productTitle), 1)
      ]),
      type: _withCtx(({ row }) => [
        _createElementVNode("div", null, _toDisplayString(_unref(ProductTypes).find((v) => v.value === Number(row.productType))?.label), 1)
      ]),
      property: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(_unref(goodsPropName)(row).join(';')), 1)
      ]),
      goodsCountry: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(sourceCountry.find(item => item.value === row?.goodsCountry)?.label), 1)
      ]),
      goodsCountryTitle: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('商品国家')) + " ", 1),
        _createVNode(_component_el_tooltip, {
          effect: "light",
          placement: "top",
          "popper-class": "tool-tip-no-border"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('不同国家的商品无法组合')), 1)
          ]),
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      price: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(_unref(formatMoney)(row.productSellPrice || row.unitPrice) + _unref(tCurrency)('CNY', row.goodsCountry ?? row.country)), 1)
      ]),
      _: 1
    }, 8, ["page-data", "columns", "filterData", "api", "row-class-name"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: commit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('加入组合')) + " (" + _toDisplayString(Object.values(_unref(selected)).length) + ")", 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})